"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _taskConfig = require("@/api/taskConfig/taskConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserTaskStatusList',
  data: function data() {
    return {
      times: [],
      loading: false,
      searchForm: {
        startTime: '',
        endTime: '',
        taskTitle: '',
        cardNo: '',
        mobile: '',
        // ✅ 新增字段
        status: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      statusMap: {
        todo: '待完成',
        ready: '可领取',
        done: '已领取',
        loading: '领取中'
      },
      downloadLoading: false
    };
  },
  methods: {
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
        console.log((0, _typeof2.default)(e[0]), e[0]);
      }
    },
    download: function download() {
      var _this = this;
      this.downloadLoading = true;
      var params = {
        status: this.searchForm.status,
        taskTitle: this.searchForm.taskTitle,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      (0, _taskConfig.exportData)(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '会员任务列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.downloadLoading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      (0, _taskConfig.getUserTaskStatusList)(this.searchForm).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        taskTitle: '',
        cardNo: '',
        mobile: '',
        // ✅ 重置手机号
        status: '',
        page: 1,
        limit: 10,
        total: 0
      };
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    handleStatusClick: function handleStatusClick(row) {
      var _this3 = this;
      if (row.status !== 'loading') return;
      this.$confirm('是否将该记录修改为已领取状态？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        (0, _taskConfig.optStatus)({
          id: row.id,
          status: 'done'
        }).then(function () {
          _this3.$message.success('已更新为已领取');
          _this3.fetchList();
        });
      }).catch(function () {});
    },
    formatTimestamp: function formatTimestamp(ts) {
      if (!ts) return '-';
      var time = Number(ts);
      if (isNaN(time)) return '-';
      var date = new Date(time);
      return date.toLocaleString();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};